import { render } from "./TopUpOnce.vue?vue&type=template&id=4ad2ecf0"
import script from "./TopUpOnce.vue?vue&type=script&lang=js"
export * from "./TopUpOnce.vue?vue&type=script&lang=js"

import "./TopUpOnce.vue?vue&type=style&index=0&id=4ad2ecf0&lang=scss"

import exportComponent from "/appl/bamboo/bamboo-agent-home-5/xml-data/build-dir/PORTAL-DREITVWEBUI-JOB1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__